import { render, staticRenderFns } from "./ActivityManageTab.vue?vue&type=template&id=dd57ef64&scoped=true"
import script from "./ActivityManageTab.vue?vue&type=script&lang=js"
export * from "./ActivityManageTab.vue?vue&type=script&lang=js"
import style0 from "./ActivityManageTab.vue?vue&type=style&index=0&id=dd57ef64&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd57ef64",
  null
  
)

export default component.exports